module.exports = __webpack_public_path__ + "media/application/images/partners/footer_logos-488474e49e1c6ea93c2922e63bbecd13.png";